<template>
  <a
    v-if="teamMember.has_details"
    :href="`/team-members/${teamMember.seo_url}`"
    class="no-hover"
    aria-label="Detail View"
  >
    <div class="group -flex -vs-center team-member-card">
      <div class="avatar">
        <img :src="thumbnailImageUrl" />
      </div>
      <div class="name-role">
        <div class="name">{{ teamMember.name }}</div>
        <div class="role">{{ teamMember.position }}</div>
      </div>
      <i v-if="teamMember.has_details" class="material-symbols-outlined fill">navigate_next</i>
    </div>
  </a>

  <div v-else class="group -flex -vs-center team-member-card">
    <div class="avatar">
      <img :src="thumbnailImageUrl" />
    </div>
    <div class="name-role">
      <div class="name">{{ teamMember.name }}</div>
      <div class="role">{{ teamMember.position }}</div>
    </div>
    <i v-if="teamMember.has_details" class="material-symbols-outlined fill">navigate_next</i>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import { mapState } from 'pinia'
import { useUserAuthStore } from '@/stores/user-auth'

export default defineComponent({
  name: 'TeamMemberCard',
  components: {},
  props: {
    teamMember: {
      type: Object as PropType<any>, // TODO: define/build model type
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(useUserAuthStore, ['cdn']),

    imageUrlPrefix() {
      // get siteassets url from page load, allows CDN url to be added
      const siteAssetsPrefix = this.cdn.siteAssetsPrefix || '/siteassets'
      return siteAssetsPrefix + '/team-members'
    },

    thumbnailImageUrl() {
      return this.imageUrlPrefix.concat('/thumb/'.concat(this.teamMember.thumbnail_image))
    },
  },

  methods: {},
})
</script>
